import AssistedClockIn from 'features/timesheets/TimesheetsPage/TimecardModal/ReadMode/TimecardSection/Issues/AssistedClockIn';
import AutoClockOut from 'features/timesheets/TimesheetsPage/TimecardModal/ReadMode/TimecardSection/Issues/AutoClockOut';
import EmployeeEdit from 'features/timesheets/TimesheetsPage/TimecardModal/ReadMode/TimecardSection/Issues/EmployeeEdit';
import Late from 'features/timesheets/TimesheetsPage/TimecardModal/ReadMode/TimecardSection/Issues/Late';
import LateClockOut from 'features/timesheets/TimesheetsPage/TimecardModal/ReadMode/TimecardSection/Issues/LateClockOut';
import MissingClockOut from 'features/timesheets/TimesheetsPage/TimecardModal/ReadMode/TimecardSection/Issues/MissingClockOut';
import NoShow from 'features/timesheets/TimesheetsPage/TimecardModal/ReadMode/TimecardSection/Issues/NoShow';
import OverScheduled from 'features/timesheets/TimesheetsPage/TimecardModal/ReadMode/TimecardSection/Issues/OverScheduled';
import Overtime from 'features/timesheets/TimesheetsPage/TimecardModal/ReadMode/TimecardSection/Issues/Overtime';
import UnscheduledShift from 'features/timesheets/TimesheetsPage/TimecardModal/ReadMode/TimecardSection/Issues/UnscheduledShift';

export const ISSUE_COMPONENT_MAP = {
  assisted_clock_in: AssistedClockIn,
  auto_clock_out: AutoClockOut,
  late: Late,
  over_scheduled: OverScheduled,
  no_show: NoShow,
  missing_clock_out: MissingClockOut,
  unscheduled_shift: UnscheduledShift,
  overtime: Overtime,
  employee_edit: EmployeeEdit,
  late_clock_out: LateClockOut,
};

export const ISSUE_PRIORITIES = {
  assisted_clock_in: 1,
  late: 2,
  no_show: 3,
  late_clock_out: 4,
  missing_clock_out: 5,
  auto_clock_out: 6,
  over_scheduled: 7,
  unscheduled_shift: 8,
  overtime: 9,
  employee_edit: 10,
  default: 99,
};
